const date = useTeamUpSessionStorage('calendar-date', (new Date()).toISOString().substring(0, 10))

export function useCalendarDateState() {
  return date
}
